import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));

const CronManager = () => {
  const classes = useStyles();
  const [crons, setCrons] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCrons();
  }, []);

  const fetchCrons = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/cronjobs");
      setCrons(data);
    } catch (err) {
      toast.error("Error al cargar crons");
    }
    setLoading(false);
  };

  const handleToggle = async (cronId, currentStatus) => {
    try {
      await api.put(`/cronjobs/${cronId}`, { isActive: !currentStatus });
      toast.success("Estado del cron actualizado correctamente");
      fetchCrons();
    } catch (err) {
      toast.error("Error al actualizar estado del cron");
    }
  };

  return (
    <Paper className={classes.mainPaper} elevation={0}>
      <Typography variant="h5" className={classes.title}>
        Crons Activos
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Patrón</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell align="center">Activo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {crons.map((cron) => (
              <TableRow key={cron.id}>
                <TableCell>{cron.name}</TableCell>
                <TableCell>{cron.pattern || "N/A"}</TableCell>
                <TableCell>{cron.description || "-"}</TableCell>
                <TableCell align="center">
                  <Switch
                    checked={cron.isActive}
                    onChange={() => handleToggle(cron.id, cron.isActive)}
                    color="primary"
                    disabled={loading}
                  />
                </TableCell>
              </TableRow>
            ))}
            {crons.length === 0 && !loading && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No hay crons registrados en la base de datos.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CronManager;
